<template>
    <div class="content-wrap content-wrap--bigger">
        <kapp-header id="mainHeader" :show-header="listScrollable"></kapp-header>


        <div class="form">

            <div class="post">

                <p class="form-fieldwrap post-category" v-if="categories.length > 0">
                    <label>Wähle eine Kategorie aus</label>
                    <select v-model="postData.category">
                        <option v-for="cat in categories" :value="cat.uid" :key="cat.uid">{{cat.title}}</option>
                    </select>
                </p>
                <p class="form-fieldwrap">
                    <label>Lade ein Bild hoch (optional)</label>
                    <span class="form-file">Bild auswählen<input type="file" ref="file" class="form-file" @change="fileSelected" accept="image/*"></span>
                    <span v-if="preview" class="file-preview">
                        <img :src="preview" />
                    </span>
                </p>

                <p class="post-text form-fieldwrap">
                    <label>Gib deine Nachricht ein</label>
                    <textarea rows="6" cols="25" :maxlength="maxLength > 0 ? maxLength : false" placeholder="Neuer Kommentar ..." v-model="postData.description"></textarea>
                    <small v-if="maxLength > 0">max. {{maxLength}} Zeichen</small>
                </p>
            </div>
            <p class="submit">
                <button @click="submit" class="button button--primary button--submit" :disabled="dataSend" :class="{'is-loading': dataSend}">Post absenden <i class="icon-load" v-show="dataSend"></i></button>
            </p>
        </div>

    </div>
</template>

<script>
    import Header from '../layouts/Header';
    import store from "@/utils/store";
    import api, { ApiDefaults } from '../../utils/api_call';
    import { ADD_ARTICLE } from '../../utils/store/actions/general';

    export default {
        name: "KappDashboardNew",
        data() {
            return {
                listScrollable: true,
                postData: {
                    category: 30,
                    description: '',
                    file: null
                },
                maxLength: 0,
                dataSend: false,
                preview: false
            };
        },
        components: {
            'kapp-header': Header
        },
        props: [],
        computed: {
            categories() {
                return (this.$route.name === 'AktuellesNew' ? [
                    {uid: 30, title: 'Suche'},
                    {uid: 31, title: 'Biete'},
                    {uid: 29, title: 'Diskussion'}
                ] : []);
            }
        },
        methods: {
            fileSelected: function () {
                this.postData.file = this.$refs.file.files[ 0 ];
                this.preview = URL.createObjectURL(this.postData.file);
            },
            submit: function () {
                this.dataSend = true;
                let user = store.getters.getProfile,
                    postData = new FormData(),
                    apiParams = {};
                postData.append('tx_c3json_jsondataplugin[controller]', 'JsonDataNews');
                postData.append('tx_c3json_jsondataplugin[action]', 'createBulletin');
                postData.append('tx_c3json_jsondataplugin[news][bodytext]', this.postData.description);
                postData.append('tx_c3json_jsondataplugin[news][category]', this.postData.category);
                postData.append('tx_c3json_jsondataplugin[file]', this.postData.file);
                postData.append('tx_c3json_jsondataplugin[userId]', user.uid);

                // let formData = new FormData();
                postData.append('file', this.postData.file);

                apiParams = Object.assign({}, ApiDefaults,
                    {
                        headers: {
                            'Content-Type': 'multipart/formdata'
                        },
                        params: {id: this.$route.meta.uid},
                        method: 'post',
                        data: postData
                    }
                );

                api(apiParams)
                    .then(( response ) => {
                        this.dataSend = false;
                        console.log(response);
                        if( response.status === 200 ) {
                            let data = response.data;

                            let article = {
                                author: store.getters.getProfile,
                                uid : response.data,
                                bodytext: this.postData.description,
                                images: [{url:URL.createObjectURL(this.postData.file)}],
                                categories: [this.postData.category],
                                visible:true,
                                likes: [],
                                comments: []
                            };

                            store.commit(ADD_ARTICLE, {newArticle : article, target: (this.$route.name === 'AktuellesNew' ?  'bulletin' : 'impression' ) } );
                            this.$msg({text: 'Ihr Beitrag wurde gespeichert', background: '#14CCCC', duration: 2500, position: 'top'});
                            this.$router.go(-1);

                        }
                    });
            }
        }
    };
</script>

<style scoped>

    .button.button--submit{
        position: relative;
    }
    .button.button--submit.is-loading {
        background-color: #394452;
        border-color: #394452;
    }
    .button.button--submit.is-loading .icon-load{
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        display: inline-block;
        width: 30px;
        height: 30px;
    }
    .button.button--submit.is-loading .icon-load::after{
        content: " ";
        display: block;
        width: 26px;
        height: 26px;
        margin: 0px;
        border-radius: 50%;
        border: 2px solid #fff;
        border-color: #fff transparent #fff transparent;
        animation: lds-dual-ring 1.2s linear infinite;
    }

    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/subparts/KappDashboardNew.vue